import React from 'react';
import authContext, { AuthContext } from './authContext';

export type UseAuthHookOutput = AuthContext;

export const useAuth = (): UseAuthHookOutput => {
  const context = React.useContext(authContext);
  return context;
};
